import { render, staticRenderFns } from "./HousePrice.vue?vue&type=template&id=2cf0212d&scoped=true&"
import script from "./HousePrice.vue?vue&type=script&lang=js&"
export * from "./HousePrice.vue?vue&type=script&lang=js&"
import style0 from "./HousePrice.vue?vue&type=style&index=0&id=2cf0212d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0212d",
  null
  
)

export default component.exports